import { type UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Form, Input, Row } from 'antd';
import { createFormFields } from 'pos-client/components/shared/Form/FormUtils.ts';
import { PosFormItem } from 'pos-client/components/shared/Form/PosFormItem.tsx';
import type { RouteModel } from 'pos-shared/models/resourceManagementSchema.ts';
import type { RouteBasicDetailsModel } from 'pos-shared/models/routeSchema.ts';

interface RouteBasicDetailsProps {
  form: UseFormReturn<RouteBasicDetailsModel>;
  route?: RouteModel;
}

const BasicDetailsTabContent = ({ form }: RouteBasicDetailsProps) => {
  const { t } = useTranslation();

  return (
    <Form
      fields={createFormFields(form)}
      layout="vertical"
      requiredMark={false}
    >
      <Row>
        <Col span={24}>
          <PosFormItem
            control={form.control}
            name="name"
            label={t('common.contact.name')}
          >
            <Input />
          </PosFormItem>
        </Col>
        <Col span={24}>
          <PosFormItem
            control={form.control}
            name="description"
            label={t('common.words.description')}
          >
            <Input />
          </PosFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default BasicDetailsTabContent;
